// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h6.contact-links[data-v-e2a67e1c]{display:inline-block}@media (max-width:575px){h6.contact-links[data-v-e2a67e1c]{font-size:14px}}", ""]);
// Exports
module.exports = exports;
